export default "__VITE_ASSET__aNaYzZ$W__"